"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var splitSearchParams = function splitSearchParams(search) {
  var searchString = search;

  if (searchString.charAt(0) === '?') {
    searchString = search.substr(1);
  }

  var table = searchString.split('&').map(function (pair) {
    return pair.split('=');
  });
  var result = {};
  table.forEach(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    result[key] = value;
  });
  return result;
};

var _default = splitSearchParams;
exports.default = _default;